// extracted by mini-css-extract-plugin
module.exports = {"page":"PickChapterPage_page__1LQg2","close_button":"PickChapterPage_close_button__3oBaD","title":"PickChapterPage_title__2CvgM","box_area":"PickChapterPage_box_area__2kaEC"};